import { ChartUnit } from '@client/graphql/__generated__/types';
import { BaseAxisProps } from 'recharts/types/util/types';
import { formatPercent } from '~/common/utils/formatter';

interface GetValueFormatterProps {
  unit?: ChartUnit;
  short?: boolean;
  length?: number;
}

export const getValueFormatter = ({
  unit,
  short = true,
  length,
}: GetValueFormatterProps): BaseAxisProps['tickFormatter'] => {
  if (unit === ChartUnit.PERCENT) {
    return (value?: number) => {
      if (isNaN(value as number)) return '';

      return formatPercent(value as number, 1) as string;
    };
  } else if (unit === ChartUnit.DAYS) {
    return (value?: number, index?: number) => {
      const shouldShowPlus = !!length && index === length - 1;

      return !isNaN(value as number)
        ? `${value}${short ? 'd' : ' days'}${shouldShowPlus ? '+' : ''}`
        : '';
    };
  } else {
    return (value: string) => {
      return value;
    };
  }
};
